import axios from "axios";
export const aiapi_url = `${process.env.REACT_APP_AUTHENTICATION_API}`;
const apiClient = axios.create({
  baseURL: aiapi_url,
});

apiClient.interceptors.request.use((request) => {
  const usersInfo = JSON.parse(localStorage.getItem("usersInfo") || "{}");
  const token = usersInfo?.token?.access;
  request.headers.Authorization = "Bearer " + token;
  return request;
});

apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    console.log(err);
    // if (err?.response?.status === 401) {
    //     logout();
    // }
  }
);

export default apiClient;
